interface PercentageValueProps {
  value: number
  className?: string
  showSign?: boolean
  element?: 'span' | 'strong'
}

export function PercentageValue({
  value,
  className = '',
  showSign = false,
  element = 'span',
}: PercentageValueProps) {
  const percentage = Math.round(value * 100)
  const sign = percentage < 0 ? '−' : showSign && percentage > 0 ? '+' : ''
  const number = Math.abs(percentage)
  const Element = element

  return (
    <Element
      className={`percentage-value${className ? ` ${className}` : ''}`}
      aria-label={`${sign}${number}%`}
    >
      {sign && <span className="percentage-sign" aria-hidden="true">{sign}</span>}
      <span className="percentage-number">{number}</span>
      <span className="percentage-symbol" aria-hidden="true">%</span>
    </Element>
  )
}
